import PropTypes from 'prop-types';
import React from 'react';

import Icon from '../../components/Icon/Icon';

import './SectionCircle.scss';

export class SectionCircle extends React.Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    svg: PropTypes.object.isRequired,
    sectionRef: PropTypes.object.isRequired,
    callback: PropTypes.func,
    isIEorEdge: PropTypes.bool,
  };

  scrollToSection = (event, ref, callback, IE) => {
    const buttonOffset = 35;

    event.preventDefault();

    if (IE) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.scroll({
        top: ref.current.offsetTop + buttonOffset,
        behavior: 'smooth',
      });
    }

    if (callback) {
      callback();
    }
  };

  render() {
    const { type, svg, sectionRef, callback, isIEorEdge } = this.props;
    const scrollId = `#${type}`;

    return (
      <a
        href={scrollId}
        onClick={event => {
          this.scrollToSection(event, sectionRef, callback, isIEorEdge);
        }}
      >
        <div className='SectionCircle'>
          <Icon className={`icon-${type}`} glyph={svg} />
        </div>
      </a>
    );
  }
}

export default SectionCircle;
